import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getOnAccountList = createAsyncThunk(
  "get-on-account",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("on-account/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const createOnAccount = createAsyncThunk(
  "create-on-account",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("on-account", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const editOnAccount = createAsyncThunk(
  "edit-on-account",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`on-account/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateOnAccount = createAsyncThunk(
  "update-on-account",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/on-account/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deleteOnAccount = createAsyncThunk(
  "delete-on-account",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/on-account/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const onAccountSlice = createSlice({
  name: "onAccount",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getOnAccountList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOnAccountList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.on_account_list;
        state.perPage = action?.payload?.data?.data?.per_page;
        state.total = action?.payload?.data?.data?.total;
      })
      .addCase(getOnAccountList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default onAccountSlice.reducer;
